import React from 'react';
import { BUILT } from '../../data/content';
import SectionHeader from '../SectionHeader';
import { useIntersection } from '../../hooks/useIntersection';

export default function Built() {
  const { ref, visible } = useIntersection();
  return (
    <section id="built" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={BUILT.sectionNum} title={BUILT.title} titleEm={BUILT.titleEm} body={BUILT.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {BUILT.items.map((item, i) => (
            <div key={i} style={{
              display: 'flex', gap: 18, alignItems: 'flex-start',
              padding: '18px 20px', background: 'var(--gray-lt)',
              borderRadius: 8, borderLeft: '3px solid var(--g2)',
            }}>
              <span style={{ fontSize: 20, minWidth: 28, marginTop: 2 }}>{item.icon}</span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink)', marginBottom: 4 }}>{item.title}</div>
                <div style={{ fontSize: 13, color: 'var(--gray)', lineHeight: 1.6 }}>{item.body}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
